export const baseUrl = document.location.hostname === "localhost" ? "https://localhost:7285" : "";

export type BackendData = {
    data: {
        categories: {
            documentId: string,
            updatedAt: string,
            title: string,
            slug: string,
            products: {
                documentId: string,
            }[] | null,
        }[],
        products: {
            documentId: string,
            updatedAt: string,
            title?: string,
            slug?: string,
            description?: string,
            isAddon: boolean,
            itemPrice: number | undefined,
            dayPrice: number | undefined,
            weekendPrice: number | undefined,
            monthPrice: number | undefined,
            addonCategories: {
                documentId: string
            }[] | null,
            mandatoryAddons: {
                documentId: string
            }[] | null,
            images: {
                url: string,
                mime: string,
                alternativeText: string,
                height: number,
                width: number,
            }[] | null;
        }[],
    }
}

export async function getBackendData(): Promise<BackendData> {
    let res = await fetch(baseUrl + "/api/data");
    let json = await res.json();
    return json as BackendData;
}
